import { render, staticRenderFns } from "./AnswerAnalysis.vue?vue&type=template&id=70a53165&scoped=true"
import script from "./AnswerAnalysis.vue?vue&type=script&lang=js"
export * from "./AnswerAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AnswerAnalysis.vue?vue&type=style&index=0&id=70a53165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a53165",
  null
  
)

export default component.exports